var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusculaChevron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 542.197,
    height: 355.043,
    viewBox: "0 0 406.647 266.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee2828",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M610.895 323.813 470.539 183.457c-.125-.125-.281-.207-.406-.332-.106-.105-.172-.23-.274-.336-24.386-24.387-64.293-24.387-88.675 0l-140.36 140.356c-24.383 24.386-24.383 64.292 0 88.68 24.387 24.386 64.293 24.386 88.68 0l96.023-96.024 96.692 96.687c24.386 24.39 64.289 24.39 88.676 0 24.386-24.383 24.386-64.289 0-88.676",
    transform: "translate(-222.537 -164.499)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusculaChevron);
export default __webpack_public_path__ + "static/media/muscula_chevron.278d02802e6f39b60b14ca58188ba9b3.svg";
export { ForwardRef as ReactComponent };